import { useState, useEffect } from "react";
import { KofidesLogo, Btn, Card, Inp, Lbl } from "../ui";
import { kofidesAdminApiFetchChecked } from "./kofidesAdminUtils";

var NEW_CUENTA_BLANK = { nombre: "", slug: "", admin_username: "", admin_password: "", admin_nombre: "" };

function CuentaFormModal(p) {
  var editing = p.editing;
  var [form, setForm] = useState(editing ? { nombre: editing.nombre } : NEW_CUENTA_BLANK);
  var [err, setErr] = useState("");
  var [busy, setBusy] = useState(false);

  function setF(k, v) { setForm(function (f) { return Object.assign({}, f, { [k]: v }); }); }

  function confirm() {
    if (!form.nombre.trim()) { setErr("El nombre es requerido."); return; }
    if (!editing) {
      if (!form.slug.trim()) { setErr("El identificador es requerido."); return; }
      if (!form.admin_username || !form.admin_password || !form.admin_nombre) {
        setErr("Completa los datos del primer usuario admin."); return;
      }
    }
    setBusy(true); setErr("");
    p.onConfirm(form).catch(function (e) { setErr(e.message); setBusy(false); });
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 24, width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <p style={{ fontSize: 15, fontWeight: 700, color: "#0f172a", margin: "0 0 16px" }}>{editing ? "Editar cuenta" : "Nueva cuenta"}</p>

        <div style={{ marginBottom: 12 }}>
          <Lbl c="Nombre" />
          <Inp value={form.nombre} onChange={function (e) { setF("nombre", e.target.value); }} />
        </div>

        {!editing ? (
          <div>
            <div style={{ marginBottom: 12 }}>
              <Lbl c="Identificador (solo minusculas, numeros, guion bajo)" />
              <Inp value={form.slug} onChange={function (e) { setF("slug", e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "")); }} />
              <p style={{ fontSize: 11, color: "#94a3b8", margin: "4px 0 0" }}>{"Base de datos: kofides_cuenta_" + (form.slug || "...")}</p>
            </div>
            <div style={{ borderTop: "1px solid #f1f5f9", paddingTop: 12, marginTop: 4, marginBottom: 12 }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", margin: "0 0 10px" }}>Primer usuario (admin de la cuenta)</p>
              <div style={{ marginBottom: 12 }}><Lbl c="Nombre completo" /><Inp value={form.admin_nombre} onChange={function (e) { setF("admin_nombre", e.target.value); }} /></div>
              <div style={{ marginBottom: 12 }}><Lbl c="Usuario" /><Inp value={form.admin_username} onChange={function (e) { setF("admin_username", e.target.value); }} /></div>
              <div style={{ marginBottom: 12 }}><Lbl c="Contrasena" /><Inp type="password" value={form.admin_password} onChange={function (e) { setF("admin_password", e.target.value); }} /></div>
            </div>
          </div>
        ) : null}

        {err ? <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginBottom: 12 }}>{err}</div> : null}

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={p.onCancel} style={{ flex: 1, padding: "10px 0", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Cancelar</button>
          <Btn onClick={confirm} sx={{ flex: 1 }}>{busy ? "Guardando..." : "Guardar"}</Btn>
        </div>
      </div>
    </div>
  );
}

export default function KofidesAdminApp() {
  var [cuentas, setCuentas] = useState([]);
  var [loading, setLoading] = useState(true);
  var [listErr, setListErr] = useState("");
  var [formModal, setFormModal] = useState(null);

  function load() {
    setListErr("");
    kofidesAdminApiFetchChecked("/cuentas").then(function (d) {
      setCuentas(d.cuentas || []); setLoading(false);
    }).catch(function (e) {
      setListErr(e.message); setLoading(false);
    });
  }
  useEffect(function () { load(); }, []);

  async function saveCuenta(form) {
    if (formModal.editing) {
      await kofidesAdminApiFetchChecked("/cuentas/" + formModal.editing.id, { method: "PUT", body: JSON.stringify(form) });
    } else {
      await kofidesAdminApiFetchChecked("/cuentas", { method: "POST", body: JSON.stringify(form) });
    }
    setFormModal(null); load();
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f7f9fc", padding: "32px 20px" }}>
      {formModal ? <CuentaFormModal editing={formModal.editing} onCancel={function () { setFormModal(null); }} onConfirm={saveCuenta} /> : null}

      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 8 }}>
          <KofidesLogo size={40} />
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", margin: 0 }}>Cuentas (multi-tenencia)</h1>
            <p style={{ color: "#64748b", fontSize: 13, margin: "2px 0 0" }}>Panel interno de plataforma -- una cuenta, una base de datos separada</p>
          </div>
        </div>

        <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "10px 16px", fontSize: 13, color: "#92400e", margin: "16px 0 24px" }}>
          Panel temporal sin login: no esta conectado al flujo de autenticacion real de Kofides todavia. Es solo para probar el mecanismo de creacion de cuentas/bases de datos.
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <p style={{ margin: 0, color: "#64748b", fontSize: 13 }}>{cuentas.length + " cuenta" + (cuentas.length === 1 ? "" : "s")}</p>
          <Btn onClick={function () { setFormModal({ editing: null }); }}>+ Nueva cuenta</Btn>
        </div>

        {listErr ? <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 16px", fontSize: 13, color: "#dc2626", marginBottom: 16 }}>{listErr}</div> : null}

        {loading ? (
          <p style={{ color: "#64748b", fontSize: 14 }}>Cargando...</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {cuentas.map(function (cta) {
              return (
                <Card key={cta.id} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                  <div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: 14, color: "#0f172a" }}>{cta.nombre}</p>
                    <p style={{ margin: "2px 0 0", fontSize: 12, color: "#64748b" }}>{cta.slug + " · " + cta.db_name + (cta.activa ? "" : " · inactiva")}</p>
                  </div>
                  <button onClick={function () { setFormModal({ editing: cta }); }} style={{ padding: "7px 14px", borderRadius: 8, border: "1px solid #dde3f0", background: "#fff", color: "#374151", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Editar</button>
                </Card>
              );
            })}
            {cuentas.length === 0 ? <p style={{ color: "#94a3b8", fontSize: 13 }}>No hay cuentas registradas.</p> : null}
          </div>
        )}
      </div>
    </div>
  );
}
